module.exports = "lui-checkbox input{display:none}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-checkbox/theme/lui-checkbox.global.scss
// module id = 188
// module chunks = 0 1 17